import { BlockType, DisplayLogic } from '@common/entities';

import { Form } from 'types/form';

interface FormElementWithDisplayLogic {
  id?: string;
  customType?: string | null;
  displayLogic?: DisplayLogic;
}

const referencesInstallmentPlanBlock = (
  displayLogic: DisplayLogic | undefined,
  installmentPlanBlockIds: ReadonlySet<string>,
): boolean =>
  Boolean(
    displayLogic?.displayConditions?.some(
      ({ sourceBlockId }) => sourceBlockId && installmentPlanBlockIds.has(sourceBlockId),
    ),
  );

export const hasInstallmentPlanCountLogic = (form?: Form): boolean => {
  const sections = form?.pages?.flatMap((page) => page.sections ?? []) ?? [];
  const installmentPlanBlockIds = new Set(
    sections.flatMap((section) => {
      const elements = (section.elements ?? []) as FormElementWithDisplayLogic[];
      return elements
        .filter(({ customType, id }) => customType === BlockType.InstallmentPlans && id)
        .map(({ id }) => id as string);
    }),
  );

  if (installmentPlanBlockIds.size === 0) return false;

  return sections.some((section) => {
    const elements = (section.elements ?? []) as FormElementWithDisplayLogic[];
    return (
      referencesInstallmentPlanBlock(section.displayLogic, installmentPlanBlockIds) ||
      elements.some((element) =>
        referencesInstallmentPlanBlock(element.displayLogic, installmentPlanBlockIds),
      )
    );
  });
};
